export class Treatmentlocationrequest {
  treatmentId: number;
  locationId: number;
  workingHours: any;
 // treatmentType: any;
}
